<template>
    <div class="highlight-item-container">
        <div class="highlight-item">
            <div class="col primary-image-container">
                <img class="primary-image" :src="options.primary_image.url" >
            </div>
            <div class="col content content-padding bg-white">
                <div class="top-title" v-if="options.content.top_title" v-html="options.content.top_title"></div>
                <h2 class="title" v-if="options.content.title" v-html="options.content.title"></h2>
                <div class="description" v-if="options.content.description" v-html="options.content.description"></div>
                <div class="button-container" v-if="options.content.button">
                    <a :href="options.content.button.url" :target="options.content.button.target" class="hover-button orange" v-html="options.content.button.title"></a>
                </div>
            </div>
            <div class="col" v-if="options.secondary_images">
                <div class="secondary-image-container secondary-container">
                    <img v-for="(image, index) in options.secondary_images" :src="image.url" :key="index">
                </div>
            </div>
            <slot name="custom-column"></slot>
        </div>

        <div class="mobile-highlight-item">
            <div class="case-study card">
                <img class="primary-image" :src="options.primary_image.url" >
                <h2 class="title" v-if="options.content.title" v-html="options.content.title"></h2>
                <div class="button-container" v-if="options.content.button">
                    <a :href="options.content.button.url" :target="options.content.button.target" class="hover-button orange" v-html="options.content.button.title"></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Object,
            required: true
        }
    },
}
</script>

<style>

</style>